module.exports = __webpack_public_path__ + "img/sug1.8cec6ac5.png";